/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M174.759 331.517v73.662a10.628 10.628 0 0017.4 8.205l180.884-148.947a10.636 10.636 0 003.877-8.205c0-3.192-1.425-6.203-3.877-8.24L192.16 99.043c-3.174-2.615-7.592-3.174-11.306-1.389a10.602 10.602 0 00-6.095 9.612v224.251z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconPlay = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconPlay.defaultProps = {
  theme,
};
IconPlay.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconPlay.displayName = 'IconPlay';
export { IconPlay };
